import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { CustomFontAwesomeIconProps } from './types/custom-font-awesome-icon.props';

/**
 * Stacked icon combining a calendar (background) and a database badge (lower-right foreground).
 *
 * Any `transform` passed via props is forwarded to the calendar layer only.
 * The database badge uses a fixed transform so its position is always consistent
 * regardless of the caller's transform intent.
 *
 * @see {@link CustomFontAwesomeIconProps}
 *
 * @example
 * ```tsx
 * <CalendarDatabase size="2x" />
 * <CalendarDatabase color="blue" fixedWidth />
 * ```
 */
export const CalendarDatabase = ({ transform, ...props }: CustomFontAwesomeIconProps) => {
  return (
    <span className="fa-layers">
      <FontAwesomeIcon
        icon={['fasr', 'calendar']}
        transform={transform}
        widthAuto
        {...props}
      />
      <FontAwesomeIcon
        icon={['fass', 'database']}
        transform="shrink-8 down-5 right-5"
        widthAuto
        {...props}
      />
    </span>
  );
};
